import { render } from "./TarasulStatusChart.vue?vue&type=template&id=fb60dd8c"
import script from "./TarasulStatusChart.vue?vue&type=script&lang=js"
export * from "./TarasulStatusChart.vue?vue&type=script&lang=js"
script.render = render

export default script